import React, { useCallback } from 'react';
import Layout from '../Layout';
import { Container, Flex, Text } from '@chakra-ui/react';

const ProcessingPage = () => {
  const headerRenderer = useCallback(() => {
    return (
      <Container textAlign="center" color="#1B2559">
        <Text fontSize="2.1rem">Payment Processing</Text>
      </Container>
    );
  }, []);

  const bodyRenderer = useCallback(() => {
    return (
      <Container textAlign="center" fontSize="1.2rem" fontWeight="400">
        <Text>
          Thank you for choosing our service! We're currently processing your
          transaction, which should be completed shortly. If you find yourself
          stuck on this page, don't worry - simply check back later, as we're
          diligently verifying your payment details.
        </Text>
        <Text mt="1.2rem">
          For assistance, feel free to reach out to us via email at ***********
        </Text>
      </Container>
    );
  }, []);

  return (
    <Layout
      color="#1B2559"
      header={headerRenderer}
      gridHeaderRegionHeight="9.5rem"
      body={bodyRenderer}
      hasGenericFooter={true}
      showBackgroundImage={true}
    />
  );
};

export default ProcessingPage;
